import { IpLogAPI } from "../adapters/MachineVersionDetailsAdapter/IpLogAdapter";

let ipLogsCache = null;

export const findCachedIpLog = (machineUDI) => {
  const list = Array.isArray(ipLogsCache?.data) ? ipLogsCache.data : [];
  return list.find((item) => item.machineUDI === machineUDI) || null;
};

export const getIpLogs = () => {
  const promise = new Promise(function (resolve, reject) {
    IpLogAPI().then((res) => {
      if (res && res.data && res.status === 200) {
        const response = res.data;
        ipLogsCache = response;
        resolve(response);
      } else {
        if (res && res.data && res.data.error && res.data.error.message) reject(res.data.error.message);
        else reject("error occured");
      }
    }).catch((err) => {
      reject(err);
    });
  });

  return promise;
};
